module.exports = __webpack_public_path__ + "static/media/10.db82935a.jpg";